import Rest from '../Rest'

export default class GedService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/ged'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  getDocumentByParamEncrypt(paramEncrypt: string){
    return this.get(`/public/${paramEncrypt}`)
  }

  validateDocumentAccessCode(paramEncrypt: string, code: String){
    return this.get(`/public/${paramEncrypt}/access_code/validate?code=${code}`)
  }

  sendValidationAccessCode(paramEncrypt: string){
    return this.get(`/public/${paramEncrypt}/access_code`)
  }

  downloadAll(paramEncrypt: string, documentName: string) {
    return this.download(`/public/${paramEncrypt}/files/download`, documentName, 'application/x-zip')
  }

  getFilesDownloadLink(paramEncrypt: string){
    return this.get(`/public/${paramEncrypt}/download/link`)
  }

}
